export default __webpack_public_path__ + "static/media/books-65.da377d39.jpg";